<template>
  <div v-if="!item.hidden" class="icas_menu-wrapper">
    <!-- {{ JSON.stringify(item.isNest) + "" + hasOneShowingChild(item.children,item) + JSON.stringify(item)+"11111111" + JSON.stringify(item.children) }} -->
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':item.isNest, 'is-active': isActiveMenuItem}">
          <item :class="{}" :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="generateTitle(onlyOneChild.meta.title)" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="generateTitle(item.meta.title)" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import { generateTitle } from '@/utils/i18n'
import Item from './Item'
import AppLink from './Link'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  computed: {
    // 遇到一个问题 如果单item点击一次不会展示只能点击第二次才会redirect，所以在这里单独做判断
    // tood 逻辑是有问题的
    isActiveMenuItem() {
      console.log(33333333, this.item)
      if (this.item.children && this.item.children.length === 1) {
        return this.$route.path.indexOf(this.item.path) !== -1
      } else {
        return false
      }
    },
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      // 是否有children
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          this.onlyOneChild = item
          return true
        }
      })
      // if (showingChildren.length === 1) {
      //   return true
      // }
      // 没有有就给onlyOneChild赋值
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },

    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    generateTitle
  }
}
</script>

<style lang="scss"  scoped>
.submenu-title-noDropdown{
     padding-left: 20px !important;
    font-weight: bold;
    color: #333 !important;
}

.is-active {
  .menuitem{
  color: #DC1E32 !important;
    border-right: 4px solid #DC1E32;
    background-color: #FCF2F3 !important;
}
}
</style>
